import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import Title from '@zenbusiness/common-components/Title';
import classNames from 'classnames';
import { isObject } from 'lodash';
import PropTypes from 'prop-types';

import { options } from '../DynamicTypography';

import { useStyles } from './useStyles';

const LessonTitle = ({ title, className }) => {
  const classes = useStyles();
  return (
    <div className={classNames(classes.lessonTitleContainer, className)}>
      <Title level={1} variant="md-alt" className={classes.title}>
        {isObject(title) ? documentToReactComponents(title, options) : title}
      </Title>
    </div>
  );
};

LessonTitle.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string
};

LessonTitle.defaultProps = {
  title: null,
  className: null
};

export default LessonTitle;
